import React, { Component } from 'react';

import TitleBar from './TitleBar';
import bibleJson from "../utils/bible";

class Chapter extends Component{

  render() {
    const { chapter } = this.props.match.params;

    const chapterFound = bibleJson.find( c => {
      return c.abbrev === chapter
    })

    const verseList = chapterFound.chapters.map( (c, i) => { 
      return <li key={i} onClick={() => this.props.history.push('/v/' + chapter + '/' + (i + 1))}><b>{i + 1}</b> &nbsp; <code><small>({c.length} {c.length === 1 ? "verse" : "verses"})</small></code></li>
    })

    return(
      <div>
        <TitleBar title={chapterFound.name} content={chapterFound.name + " (" + chapterFound.chapters.length + ")"} />
        <div className="Container Container--md">
          <ul className="bible-list fade-up">
            {verseList}
          </ul>
        </div>
      </div>
    )
  }
}

export default Chapter
